export default __webpack_public_path__ + "static/media/img2.1f1b03ad.jpg";